import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import Accounting from '../../../component/accounting';
import AppLayout from '../../../component/appLayout';
import {
  AddedLinkBox,
  AddedLinkBoxLeft,
  AvatarImage,
  Div,
  Dropdowns,
  GraphBox,
  Group,
  Header,
  Heading,
  LeftDiv,
  LeftSection,
  LinkIcon,
  LoadingImage,
  Milestone,
  MilestoneBox,
  PodcastDiv,
  ProfileBorder,
  ProfileGroup,
  Profiles,
  ResourceTitle,
  ResourcesFileSection,
  ResourcesSection,
  RightDiv,
  SubDiv,
  TaskDiv,
  Text,
  Top,
  WrapperDiv
} from './styles';
import {
  addFileData,
  addProjectResource,
  deleteProjectResource,
  getDocumentData,
  getMilestoneList,
  getProjectTimeLog,
  getProjectWiseActivity
} from '../../../services/projectServices';
import { useHistory, useParams } from 'react-router-dom';
import { captureException } from '../../../services/logService';
import {
  calculateDueTime,
  extensionName,
  extensionResource,
  formatBytes,
  handleFileUpload,
  isEmpty
} from '../../../helpers/common';
import Button from '../../../component/button';
import Avatar from '../../../component/avatar';
import TaskCard from './taskcard';
import SVGIcon from '../../../assets/images/svg/SVGIcon';
import {
  AVATAR_BORDER,
  BUTTON_TYPE,
  CHIP_ICON_POSITION,
  CHIP_SIZE,
  CHIP_TYPE,
  EMPTY_STATE_SIZE,
  FILE_EXTENSIONS,
  FILE_TYPES,
  FILES_MENU_OPTIONS,
  ICON_BUTTON_SIZE,
  ICON_BUTTON_TYPE,
  ICON_SIZE,
  LINK_FILE_DATA,
  MENU_OPTIONS,
  RESOURCE_TYPE,
  TimeLogMenuItems,
  USER_ROLE
} from '../../../global/constants';
import { getCustomerMembersList } from '../../../services/customerServices';
import InviteTeamsModal from '../../../component/modals/inviteTeamsModal';
import Modal from '../../../component/modals/modal';
import MilestoneModal from '../../../component/modals/milestoneModal';
import LineChart from '../../../component/chart';
import dayjs from 'dayjs';
import { ChartDataInterface, SelectionRangeInterface } from '../../../interfaces/TimeReportInterface';
import ReportTimelineLoading from '../../../component/loading/reportTimeLineLoading';
import { Dropdown, DropdownItem } from '../../../component/dropdown';
import LinkFileModal from '../../../component/modals/linkFileModal';
import FileSVGIcon from '../../../assets/images/svg/filesIconSvg';
import { useMobileDevice } from '../../../global/useMobile';
import { CommentFilesInterface } from '../../../interfaces/TaskInterface';
import {
  ProjectFileData,
  ProjectResourceDetailInterface,
  ProjectResourceInterface
} from '../../../interfaces/ProjectInterface';
import { RawProjectFile } from '../../../mobx/interfaces/project';
import FilesModal from '../../../component/modals/filesModal';
import DeleteModal from '../../../component/modals/deleteModal';
import copy from 'clipboard-copy';
import Tooltip from '../../../component/tooltip';
import FileUploadCard from '../../../component/fileUploadCard';
import { rootStore } from '../../../mobx/rootStore';
import { observer } from 'mobx-react-lite';
import { UserModel } from '../../../mobx/models/user';
import CircularProgress from '../../../component/circularProgress';
import InviteMemberModal from '../../../component/modals/inviteMemberModal';
import BottomSubNavigation from '../../../component/bottomNavigation/subNavigation';
import WorkloadCard from './workloadCard';
import RenderExistingFileV2 from '../../../component/renderExistingFile';
import { syncTasks } from '../../../services/syncService';
import ProjectActivityCard from './projectActivityCard';
import IconButton from '../../../component/button/iconButton';
import Chip from '../../../component/chipComponent';
import EmptyStateV2 from '../../../component/emptyState';
import { ROUTES } from '../../../routes/urls';

//menu items for dropdown action list for file
const fileMenuItems = [
  {
    key: FILES_MENU_OPTIONS.VIEW,
    label: 'View'
  },
  {
    key: FILES_MENU_OPTIONS.RENAME,
    label: 'Rename'
  },
  {
    key: FILES_MENU_OPTIONS.DELETE,
    label: 'Delete',
    tone: 'critical'
  }
];

//menu items for dropdown action list for added link
const menuItems = [
  {
    key: MENU_OPTIONS.COPYLINK,
    label: 'Copy link'
  },
  {
    key: MENU_OPTIONS.EDIT,
    label: 'Edit'
  },
  {
    key: MENU_OPTIONS.DELETE,
    label: 'Delete',
    tone: 'critical'
  }
];

const Overview: React.FC = () => {
  //Ref
  const fileInputRef = useRef<HTMLInputElement>(null);

  // States
  const [loading, setLoading] = useState(true);
  const [openDropdown, setOpenDropdown] = useState(false);
  const [clientList, setClientList] = useState<UserModel[]>([]);
  const [workspaceUsers, setWorkspaceUsers] = useState<UserModel[]>([]);
  const [isMainModel, setMainModel] = useState(false);
  const [isSubModel, setSubModel] = useState(false);
  const [chartLoading, setChartLoading] = useState(false);
  const [isAddMilestoneModalOpen, setIsAddMilestoneModalOpen] = useState(false);
  const [attachment, setAttachment] = useState(false);
  const [isFileModalOpen, setIsFileModelOpen] = useState(false);
  const [itemData, setItemData] = useState<ProjectFileData | null>(null);
  const [deleteModelOpen, setDeleteModelOpen] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [uploadFileDetail, setUploadFileDetail] = useState<File[]>();
  const [selectedTimelogFilter, setSelectedTimelogFilter] = useState('Last 7 days');
  const [timeChartData, setTimeChartData] = useState<ChartDataInterface>({ data: [], x_axis_data: [] });
  const [selectionRange, setSelectionRange] = useState<SelectionRangeInterface>({
    startDate: new Date(dayjs().clone().subtract(7, 'days').format('ddd MMM D YYYY 00:00:00 [GMT+0530]')),
    endDate: new Date(dayjs().format('ddd MMM D YYYY 00:00:00 [GMT+0530]')),
    key: 'selection'
  });

  const [isOpen, setIsOpen] = useState(false);
  const [isResourceDropdownOpen, setIsResourceDropdownOpen] = useState(false);
  const [selectFile, setSelectFile] = useState(false);
  //Mobx store variables
  const { projectStore, workspaceStore } = rootStore;
  const { currentProject, uploadFilePercent } = projectStore;
  const { currentWorkspace: workspace } = workspaceStore;

  // Other variables
  const params: { id: string } = useParams();
  const mobile = useMobileDevice();
  const history = useHistory();

  // for open dropdown
  const handleDropdownOpen = useCallback(() => {
    setOpenDropdown((prev) => !prev);
  }, []);

  // for open model
  const openModel = useCallback(() => {
    setIsOpen(true);
  }, []);

  const attachmentPage = useCallback(() => {
    currentProject?.setCurrentFolderId(null);
    if (mobile) {
      setSelectFile(true);
    } else {
      setAttachment(true);
    }
  }, [currentProject, mobile]);

  // for cancel model
  const cancelModel = useCallback(() => {
    setIsOpen(false);
    setItemData(null);
  }, []);

  const openSetupPeople = useCallback(() => setMainModel(true), []);

  const closeResourceDropdown = useCallback(() => {
    setIsResourceDropdownOpen(false);
  }, []);

  const toggleResourceDropdown = useCallback(() => {
    setIsResourceDropdownOpen((previousState) => !previousState);
  }, []);

  // login for load time data
  const loadTimeData = useCallback(async () => {
    try {
      setChartLoading(true);
      //project time log
      const timeDate = await getProjectTimeLog(
        params?.id,
        dayjs(selectionRange.startDate).format('DD-MM-YYYY'),
        dayjs(selectionRange.endDate).format('DD-MM-YYYY')
      );
      setTimeChartData(timeDate);
    } catch (e) {
      captureException(e);
    } finally {
      setChartLoading(false);
    }
  }, [params?.id, selectionRange.endDate, selectionRange.startDate]);

  // load initial data
  const loadData = useCallback(async () => {
    try {
      setLoading(true);
      if (!isEmpty(workspace?.id)) {
        syncTasks();

        const promises = [];
        if (currentProject?.isMilestone) {
          promises.push(getMilestoneList(params?.id, false, false));
        }
        if (
          !isEmpty(currentProject?.customerId) &&
          currentProject?.customerId &&
          (workspace?.isAdmin || workspace?.isOwner)
        ) {
          promises.push(getCustomerMembersList(currentProject?.customerId));
        }
        promises.push(getProjectWiseActivity(currentProject?.id, 1, 10));

        const result = await Promise.all(promises);
        if (!isEmpty(currentProject?.customerId) && (workspace?.isAdmin || workspace?.isOwner)) {
          const lastResult = result[result.length - 1];
          const filteredCustomers =
            lastResult?.length > 0 && workspace?.users?.length > 0
              ? workspace?.users?.filter(
                  (item) =>
                    item?.role === USER_ROLE.CLIENT && lastResult?.some((a: { id: string }) => a?.id === item?.id)
                )
              : [];

          setClientList(filteredCustomers);
        }
        const filteredWorkspaceUsers = workspace?.users?.filter((item) => item?.role !== USER_ROLE.CLIENT) || [];
        setWorkspaceUsers(filteredWorkspaceUsers);
      }
    } catch (e) {
      captureException(e);
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentProject?.id, params?.id, workspace?.id, workspace?.isAdmin, workspace?.isOwner, workspace?.users]);

  useEffect(() => {
    if (workspace?.id) {
      if (workspace?.isAdmin || workspace?.isOwner) {
        loadTimeData();
      }
    }
  }, [loadTimeData, workspace?.id, workspace?.isAdmin, workspace?.isOwner]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  //Handle project tasks count
  const tasksCount = useMemo(() => {
    const tasks = currentProject?.tasks || [];
    const completedTasks = tasks?.filter((item) => item?.status).length;
    const inCompletedTasks = tasks?.filter((item) => !item?.status)?.length;
    const overDueTasks = tasks?.filter((item) => !item?.status && calculateDueTime(item?.dueDate)?.overDue)?.length;
    return { completedTasks, inCompletedTasks, overDueTasks };
  }, [currentProject?.tasks]);

  // for close invite model
  const closeInviteModal = useCallback(() => {
    setMainModel(false);
  }, []);

  // for invite member
  const onSubModel = useCallback(() => {
    setMainModel(false);
    setSubModel(true);
  }, []);

  // for close sub model
  const onCloseSubModal = useCallback(() => {
    setSubModel(false);
  }, []);

  const handleFileInput = useCallback(() => {
    queueMicrotask(() => {
      if (fileInputRef.current) {
        fileInputRef.current.click();
      }
    });
  }, []);

  const onFileUpload = useCallback(
    async (event: React.ChangeEvent<HTMLInputElement>) => {
      const { files } = event.target;
      if (!files || files.length === 0) {
        rootStore.alertNotificationStore.setErrorMessage('No files selected.');
        return;
      }
      try {
        const fileArray = Array.from(files); // Convert FileList to Array
        setUploadFileDetail(fileArray);
        //call common function to upload file in firebase
        // Save files inside the project's own folder when we know the project id.
        const uploadFolder = currentProject?.id ? `projects/${currentProject.id}/files/` : 'files/';
        const uploadedFiles: CommentFilesInterface[] =
          (await handleFileUpload([], fileArray, undefined, undefined, uploadFolder)) || [];

        // //Handle file size
        let fileSize = 0;
        if (uploadedFiles[0]?.size) {
          fileSize = parseFloat(uploadedFiles[0]?.size); // Extracts the numeric value
          if (uploadedFiles[0]?.size?.toUpperCase().includes('MB')) {
            fileSize = fileSize * (1024 * 1024);
          } else {
            fileSize = fileSize * 1024;
          }
        }
        const payload = uploadedFiles?.map((file, index) => ({
          FileType: uploadedFiles[0].file_type,
          IsSystemFile: true,
          Name: uploadedFiles[0].name,
          ParentId: null,
          ProjectId: params?.id,
          Size: Number(fileSize),
          UploadFileType: FILE_TYPES.UPLOAD,
          Url: uploadedFiles[0]?.href,
          IsResource: true
        }));
        const response = await addFileData(payload[0]);
        if (response) {
          const data = response.data;
          const resource = {
            CreatedBy: data.CreatedBy,
            CreatedTime: data.CreatedTime,
            IsArchived: data.IsArchived,
            Label: uploadedFiles[0]?.name,
            Reference: uploadedFiles[0]?.href,
            UpdatedBy: data.UpdatedBy,
            Type: RESOURCE_TYPE.FILE,
            UpdatedTime: data.UpdatedTime,
            _id: data['_id'],
            FileType: uploadedFiles[0]?.file_type,
            UploadFileType: FILE_TYPES.UPLOAD
          };
          currentProject?.addResource(resource);
          setUploadFileDetail([]);
          rootStore.alertNotificationStore.setSuccessMessage('File uploaded successfully');
        }
      } catch (error) {
        captureException(error);
        rootStore.alertNotificationStore.setErrorMessage('Error occurred while uploading files.');
      }
    },
    [currentProject, params?.id]
  );

  const onSelectFile = useCallback(
    async (item: RawProjectFile) => {
      if (!item) return;

      const { name, uploadFileType, parentId, id, size, url, fileExt } = item;
      const isDocOrWhiteboard = uploadFileType === FILE_TYPES.DOCS || uploadFileType === FILE_TYPES.WHITEBOARD;

      let fileUrl = url;
      if (isDocOrWhiteboard) {
        fileUrl = `/projects/files/${currentProject?.id}/docs/${id}${!isEmpty(parentId) ? `?folder=${parentId}` : ''}`;
      }

      const payload: ProjectResourceInterface = {
        id: id,
        label: name,
        reference: fileUrl,
        type: RESOURCE_TYPE.FILE,
        fileType: fileExt || '',
        isSystemFile: null,
        size: Number(size),
        uploadFileType: uploadFileType
      };

      const response = await addProjectResource(currentProject?.id, payload);
      if (response) {
        currentProject?.addResource(response);
        rootStore.alertNotificationStore.setSuccessMessage('File uploaded successfully');
      }
    },
    [currentProject]
  );

  const closeFileModel = useCallback(() => {
    setItemData(null);
    setIsFileModelOpen(false);
  }, []);

  // for manage time filter
  const onChangeTimeFilter = useCallback(({ key }: { key: string }) => {
    let startDate, endDate;
    setSelectedTimelogFilter(key);
    switch (key) {
      case 'Yesterday':
        startDate = new Date(dayjs().subtract(1, 'days').format('ddd MMM D YYYY 00:00:00 [GMT+0530]'));
        endDate = new Date(dayjs().subtract(1, 'days').format('ddd MMM D YYYY 00:00:00 [GMT+0530]'));
        break;
      case 'This week':
        startDate = new Date(dayjs().clone().startOf('week').format('ddd MMM D YYYY 00:00:00 [GMT+0530]'));
        endDate = new Date(dayjs().format('ddd MMM D YYYY 00:00:00 [GMT+0530]'));
        break;
      case 'Last week':
        startDate = new Date(
          dayjs().clone().subtract(1, 'weeks').startOf('week').format('ddd MMM D YYYY 00:00:00 [GMT+0530]')
        );
        endDate = new Date(
          dayjs().clone().subtract(1, 'weeks').endOf('week').format('ddd MMM D YYYY 00:00:00 [GMT+0530]')
        );
        break;
      case 'Last 7 days':
        startDate = new Date(dayjs().clone().subtract(7, 'days').format('ddd MMM D YYYY 00:00:00 [GMT+0530]'));
        endDate = new Date(dayjs().format('ddd MMM D YYYY 00:00:00 [GMT+0530]'));
        break;
      case 'This month':
        startDate = new Date(dayjs().clone().startOf('month').format('ddd MMM D YYYY 00:00:00 [GMT+0530]'));
        endDate = new Date(dayjs().format('ddd MMM D YYYY 00:00:00 [GMT+0530]'));
        break;
      case 'Last month':
        startDate = new Date(
          dayjs().clone().subtract(1, 'months').startOf('month').format('ddd MMM D YYYY 00:00:00 [GMT+0530]')
        );
        endDate = new Date(
          dayjs().clone().subtract(1, 'months').endOf('month').format('ddd MMM D YYYY 00:00:00 [GMT+0530]')
        );
        break;
      default:
        startDate = new Date(dayjs().format('ddd MMM D YYYY 00:00:00 [GMT+0530]'));
        endDate = new Date(dayjs().format('ddd MMM D YYYY 00:00:00 [GMT+0530]'));
        break;
    }
    setSelectionRange({
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
      key: 'selection'
    });
  }, []);

  // for open milestone model
  const onOpenMilestoneModal = useCallback(() => {
    setIsAddMilestoneModalOpen(true);
  }, []);

  // for close milestone model
  const onCloseMilestoneModal = useCallback(() => {
    setIsAddMilestoneModalOpen(false);
  }, []);

  const renderedTimelogItems = useMemo(() => {
    return TimeLogMenuItems.map((item) => (
      <DropdownItem
        key={item}
        label={item}
        onClick={() => onChangeTimeFilter({ key: item })}
        isActive={selectedTimelogFilter === item}
      />
    ));
  }, [onChangeTimeFilter, selectedTimelogFilter]);

  // derive member and client users once
  const memberUsers = useMemo(
    () => currentProject?.users?.filter((item) => item?.role !== USER_ROLE.CLIENT) || [],
    [currentProject?.users]
  );

  const clientUsers = useMemo(
    () => currentProject?.users?.filter((item) => item?.role === USER_ROLE.CLIENT) || [],
    [currentProject?.users]
  );

  // render current project users
  const renderCurrentProjectUser = useMemo(() => {
    return (
      memberUsers.length > 0 &&
      memberUsers.map((item) => {
        return (
          !isEmpty(item?.id) && (
            <Tooltip placement='bottom' title={item?.name} maxWidth={'max-content'}>
              <ProfileBorder key={item?.id}>
                <Avatar
                  imgSrc={item?.profile_photo || ''}
                  name={item?.name ? item?.name : 'U N'}
                  size={30}
                  borderVariant={AVATAR_BORDER.THIN}
                />
              </ProfileBorder>
            </Tooltip>
          )
        );
      })
    );
  }, [memberUsers]);

  // render current project client data
  const renderCurrentProjectClient = useMemo(() => {
    return (
      clientUsers.length > 0 && (
        <ProfileGroup>
          {clientUsers.map((item) => {
            return (
              <Avatar
                imgSrc={item?.profile_photo || ''}
                name={item?.name ? item?.name : 'U N'}
                size={30}
                borderVariant={AVATAR_BORDER.THIN}
                key={item?.id}
              />
            );
          })}
        </ProfileGroup>
      )
    );
  }, [clientUsers]);

  // render milestone list
  const renderMilestoneList = useMemo(() => {
    return currentProject?.milestones?.map((milestone) => {
      const completedTaskList = milestone?.tasks?.filter((item) => item?.status);
      return (
        <Div key={milestone?.id}>
          <LeftDiv>
            <CircularProgress
              progressPercentage={Number(milestone?.progressData?.progress)}
              status={milestone?.progressData?.status}
            />
            <SubDiv>
              <p>
                {milestone?.milestoneName}
                <span>
                  ({completedTaskList?.length}/{milestone?.tasks?.length})
                </span>
              </p>
            </SubDiv>
          </LeftDiv>
          <RightDiv>
            <ul>
              {milestone?.users?.map((userProfile) => {
                return (
                  <li key={userProfile?.id}>
                    <AvatarImage>
                      <Avatar
                        size={20}
                        imgSrc={userProfile?.profile_photo || ''}
                        name={userProfile?.name || ''}
                        borderVariant={AVATAR_BORDER.THIN}
                      />
                    </AvatarImage>
                  </li>
                );
              })}
            </ul>
          </RightDiv>
        </Div>
      );
    });
  }, [currentProject?.milestones]);

  //Handle link menu click
  const handleLinkMenuClick = useCallback(async (key: number, file: ProjectFileData) => {
    if (key === MENU_OPTIONS.EDIT) {
      setItemData(file);
      setIsOpen(true);
    } else if (key === MENU_OPTIONS.DELETE) {
      setItemData(file);
      setDeleteModelOpen(true);
    } else if (key === MENU_OPTIONS.COPYLINK) {
      if (!file?.url) return;
      await copy(file?.url);
      rootStore.alertNotificationStore.setSuccessMessage('Link copied successfully!');
    }
  }, []);

  //render dropdown action list
  const renderActionListDropdown = useCallback(
    (file: ProjectResourceDetailInterface) => {
      const fileData: ProjectFileData = {
        id: file['_id'],
        name: file.Label || '',
        url: file.Reference || '',
        uploadFileType: file.UploadFileType || FILE_TYPES.UPLOAD
      };
      return menuItems.map((item) => (
        <DropdownItem
          label={item.label}
          key={item?.key}
          tone={item.label === 'Delete' ? 'critical' : 'primary'}
          onClick={() => handleLinkMenuClick(item?.key, fileData)}
        />
      ));
    },
    [handleLinkMenuClick]
  );

  const onClickFile = useCallback(
    async (item: ProjectFileData) => {
      if (item.type && item.type === RESOURCE_TYPE.LINK) {
        const url = new URL(item?.url!);
        window.open(url, '_blank')?.focus();
        return;
      }
      switch (item?.uploadFileType) {
        case FILE_TYPES.UPLOAD:
          history.push(
            ROUTES.PROJECT_FILE_VIEW.replace(':id', currentProject?.id || '').replace(':name', item?.id || '')
          );
          break;
        case FILE_TYPES.DRIVE:
        case FILE_TYPES.DROPBOX:
        case FILE_TYPES.ONEDRIVE:
        case FILE_TYPES.FIGMA:
        case FILE_TYPES.NOTION:
          try {
            const url = new URL(item?.url!);
            window.open(url, '_blank')?.focus();
          } catch (e) {
            captureException(e);
            rootStore.alertNotificationStore.setErrorMessage('Can not open this URL file');
          }
          break;
        case FILE_TYPES.DOCS:
        case FILE_TYPES.WHITEBOARD:
          if (!item?.url) return;
          await getDocumentData(item?.id);
          history.push(item?.url);
          break;
        default:
          break;
      }
    },
    [currentProject?.id, history]
  );

  //Handle file menu click
  const handleFileMenuClick = useCallback(
    (key: number, file: ProjectFileData) => {
      setItemData(file);
      if (key === FILES_MENU_OPTIONS.RENAME) {
        setIsFileModelOpen(true);
      } else if (key === FILES_MENU_OPTIONS.DELETE) {
        setDeleteModelOpen(true);
      } else if (key === FILES_MENU_OPTIONS.VIEW) {
        onClickFile(file);
      }
    },
    [onClickFile]
  );

  //render dropdown for file action list
  const renderFileMenuDropdown = useCallback(
    (file: ProjectResourceDetailInterface) => {
      const fileData: ProjectFileData = {
        id: file['_id'],
        name: file.Label || '',
        url: file.Reference || '',
        uploadFileType: file.UploadFileType || FILE_TYPES.UPLOAD
      };
      return fileMenuItems.map((item) => (
        <DropdownItem
          label={item.label}
          key={item?.key}
          tone={item.label === 'Delete' ? 'critical' : 'primary'}
          onClick={() => handleFileMenuClick(item?.key, fileData)}
        />
      ));
    },
    [handleFileMenuClick]
  );

  const closeDeleteModel = useCallback(() => {
    setDeleteModelOpen(false);
    setItemData(null);
  }, []);

  const onDeleteResource = useCallback(async () => {
    try {
      if (!itemData?.id) return;
      setDeleteLoading(true);
      const response = await deleteProjectResource(currentProject?.id, itemData?.id);
      if (response) {
        currentProject?.removeResource(itemData?.id);
      }
    } catch (error) {
      captureException(error);
    } finally {
      setDeleteLoading(false);
      closeDeleteModel();
    }
  }, [closeDeleteModel, currentProject, itemData?.id]);

  const renderLinks = useMemo(() => {
    return (
      currentProject?.resources &&
      currentProject?.resources?.length > 0 &&
      currentProject?.resources?.map((item) => {
        const extension = extensionResource(item).toLowerCase();
        const fileData: ProjectFileData = {
          id: item['_id'],
          name: item.Label || '',
          url: item.Reference || '',
          uploadFileType: item.UploadFileType || FILE_TYPES.UPLOAD,
          type: item.Type
        };
        return (
          <AddedLinkBox role='button' onClick={() => onClickFile(fileData)}>
            <AddedLinkBoxLeft>
              {item.Type === RESOURCE_TYPE.LINK ? (
                <LinkIcon>
                  <SVGIcon
                    name='copy-link-icon'
                    width={ICON_SIZE.MD}
                    height={ICON_SIZE.MD}
                    viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
                    fill='var(--text-primary)'
                  />
                </LinkIcon>
              ) : (!item?.UploadFileType || item?.UploadFileType === FILE_TYPES.UPLOAD) &&
                !FILE_EXTENSIONS.includes(extension) ? (
                <FileSVGIcon name={'blank'} height='16' width='16' viewBox='0 0 60 60' />
              ) : (
                <FileSVGIcon
                  name={
                    !item?.UploadFileType || item?.UploadFileType === FILE_TYPES.UPLOAD
                      ? extension
                      : `icon_${item?.UploadFileType}`
                  }
                  height='16'
                  width='16'
                  viewBox='0 0 60 60'
                />
              )}
              <Text>{item?.Label}</Text>
            </AddedLinkBoxLeft>
            <Dropdown
              modalTitle='Manage File'
              isMinWidth={140}
              activeClassName='active-more-icon'
              content={
                <IconButton
                  iconName='three-dots-horizontal-icon'
                  size={ICON_BUTTON_SIZE.EXTRA_X_SMALL}
                  variant={ICON_BUTTON_TYPE.TERTIARY}
                  className='more-icon'
                />
              }
              trigger='click'>
              {item?.Type === RESOURCE_TYPE.LINK ? renderActionListDropdown(item) : renderFileMenuDropdown(item)}
            </Dropdown>
          </AddedLinkBox>
        );
      })
    );
  }, [currentProject?.resources, onClickFile, renderActionListDropdown, renderFileMenuDropdown]);

  const renderTimeLog = useMemo(() => {
    if (!workspace?.isAdmin && !workspace?.isOwner) return;
    return (
      <GraphBox>
        <Header>
          <span>Time-logs</span>
          {(tasksCount.completedTasks > 0 || tasksCount.inCompletedTasks > 0 || tasksCount.overDueTasks > 0) && (
            <Dropdowns>
              <Dropdown
                modalTitle='Date Range'
                isMinWidth={152}
                content={
                  <Chip
                    size={CHIP_SIZE.SMALL}
                    title={selectedTimelogFilter}
                    variant={CHIP_TYPE.FILL}
                    trailingIconName='down-arrow-icon'
                    trailingIconClassName={openDropdown ? 'dropdown-icon' : ''}
                    onClick={handleDropdownOpen}
                    isActive={openDropdown}
                    iconPosition={CHIP_ICON_POSITION.TEXT_RIGHT_BUTTON}
                  />
                }
                trigger='click'
                onClickItemTrigger={handleDropdownOpen}
                onOutsideClick={handleDropdownOpen}>
                {renderedTimelogItems}
              </Dropdown>
            </Dropdowns>
          )}
        </Header>

        {/* Chart */}
        {!chartLoading ? (
          <LineChart isOverviewPage={true} projectWiseChartData={timeChartData} />
        ) : (
          <LoadingImage>
            <ReportTimelineLoading isProjectOverView={true} />
          </LoadingImage>
        )}
      </GraphBox>
    );
  }, [
    chartLoading,
    handleDropdownOpen,
    openDropdown,
    renderedTimelogItems,
    selectedTimelogFilter,
    tasksCount.completedTasks,
    tasksCount.inCompletedTasks,
    tasksCount.overDueTasks,
    timeChartData,
    workspace?.isAdmin,
    workspace?.isOwner
  ]);

  if (selectFile) {
    return (
      <RenderExistingFileV2
        setAttachment={() => setAttachment(false)}
        setSelectFile={(value: boolean) => setSelectFile(value)}
        onSelectFile={onSelectFile}
        isProjectOverview
      />
    );
  }

  return (
    <>
      <AppLayout isOverflowHidden={mobile ? false : true}>
        <Accounting />
        <WrapperDiv className='project-overview'>
          <LeftSection>
            <Group>
              <PodcastDiv>
                <Top>
                  <Heading>{currentProject?.name}</Heading>
                </Top>
                <Profiles>
                  {renderCurrentProjectUser}
                  {renderCurrentProjectClient}
                  {(workspace?.isAdmin || workspace?.isOwner) && (
                    <Button
                      title='Setup People '
                      variant={BUTTON_TYPE.SECONDARY}
                      onClick={openSetupPeople}
                      className='hide-button'
                      disabled={workspaceUsers?.length === 0}
                    />
                  )}
                </Profiles>
              </PodcastDiv>
              <ResourcesSection>
                <ResourceTitle>Resources</ResourceTitle>
                <ResourcesFileSection>
                  {renderLinks}
                  <Dropdown
                    modalTitle='Attach File or Link'
                    isMinWidth={150}
                    activeClassName={
                      currentProject?.resources && currentProject?.resources?.length !== 0 ? 'resource-item' : ''
                    }
                    onOutsideClick={closeResourceDropdown}
                    content={
                      currentProject?.resources && currentProject?.resources?.length === 0 ? (
                        <Chip
                          size={CHIP_SIZE.SMALL}
                          variant={CHIP_TYPE.FILL_WITHOUT_BORDER}
                          title={
                            currentProject?.resources && currentProject?.resources?.length === 0 ? 'File or link' : ''
                          }
                          leadingIconName='plus-icon'
                          textColorType='secondary'
                          onClick={toggleResourceDropdown}
                          isActive={isResourceDropdownOpen}
                          className={isResourceDropdownOpen ? 'resource-item' : ''}
                        />
                      ) : (
                        <IconButton
                          iconName='plus-icon'
                          size={ICON_BUTTON_SIZE.MEDIUM}
                          variant={ICON_BUTTON_TYPE.TERTIARY}
                          onClick={toggleResourceDropdown}
                        />
                      )
                    }
                    trigger='click'>
                    <>
                      <DropdownItem
                        label='Upload file'
                        iconName='upload-icon'
                        iconSize={16}
                        iconTone='fill'
                        onClick={handleFileInput}
                      />
                      <DropdownItem
                        label='Select file'
                        iconName='updated-file-icon'
                        iconSize={16}
                        iconViewBox='0 0 18 18'
                        iconTone='fill'
                        onClick={attachmentPage}
                      />
                      <DropdownItem
                        label='Add link'
                        iconName='copy-link-icon'
                        iconSize={16}
                        iconViewBox='0 0 18 18'
                        iconTone='fill'
                        onClick={openModel}
                      />
                    </>
                  </Dropdown>
                </ResourcesFileSection>
              </ResourcesSection>
              <input multiple={false} type='file' ref={fileInputRef} hidden onChange={onFileUpload} />

              {/* upload file loading state */}
              {uploadFilePercent > 0 && uploadFileDetail && (
                <FileUploadCard
                  fileName={uploadFileDetail?.[0]?.name}
                  extension={extensionName(uploadFileDetail?.[0]).toLowerCase()}
                  progress={uploadFilePercent}
                  fileSize={formatBytes(uploadFileDetail?.[0]?.size || 0)}
                />
              )}
              {/* show task number */}
              <TaskDiv>
                <TaskCard
                  heading={'Completed tasks'}
                  count={tasksCount?.completedTasks}
                  iconName={'true-icon'}
                  iconFill='var(--accent-success)'
                />
                <TaskCard
                  heading={'Incomplete tasks'}
                  count={tasksCount?.inCompletedTasks}
                  iconName={'overview-incompletetask-icon'}
                  iconFill='var(--accent-caution)'
                />
                <TaskCard
                  heading={'Overdue tasks'}
                  count={tasksCount?.overDueTasks}
                  iconName={'overview-overduetask-icon'}
                  iconFill='var(--accent-error)'
                />
              </TaskDiv>

              {/* Project's Team workload */}
              <WorkloadCard />
              <ProjectActivityCard loading={loading} />

              {/* Project's Time log*/}
              {renderTimeLog}

              {(!loading || (currentProject?.milestones && currentProject?.milestones?.length > 0)) &&
                currentProject?.isMilestone && (
                  <MilestoneBox isMilestoneEmpty={!loading && currentProject?.milestones?.length === 0}>
                    <p>Milestones</p>
                    {!loading && currentProject?.milestones?.length === 0 && (
                      <EmptyStateV2
                        size={EMPTY_STATE_SIZE.SMALL}
                        imageUrl={'milestone_empty'}
                        title='No milestones added yet'
                        buttonTitle='New Milestone'
                        onClick={onOpenMilestoneModal}
                        className='milestone-empty'
                      />
                    )}
                    {currentProject?.milestones?.length > 0 && <Milestone>{renderMilestoneList}</Milestone>}
                  </MilestoneBox>
                )}
            </Group>
          </LeftSection>
          {attachment && (
            <RenderExistingFileV2
              setAttachment={() => setAttachment(false)}
              isProjectOverview={true}
              onSelectFile={onSelectFile}
            />
          )}
        </WrapperDiv>
      </AppLayout>
      {/* Bottom Navigation */}
      <BottomSubNavigation backNavigationPath='/home' />

      <Modal open={isMainModel} onClose={closeInviteModal} maxWidth={'400px'}>
        <InviteMemberModal
          onClose={closeInviteModal}
          customersUsers={clientList}
          currentProject={currentProject!}
          workspace={workspace!}
          onSubModel={onSubModel}
          setLoading={setLoading}
        />
      </Modal>
      <Modal open={deleteModelOpen} onClose={closeDeleteModel} maxWidth={'334px'}>
        <DeleteModal
          onClose={closeDeleteModel}
          onOk={onDeleteResource}
          loading={deleteLoading}
          modalTitle={`Delete ${itemData?.uploadFileType ? 'File' : 'Link'}`}
          description={`Are you sure you want to delete this ${!itemData?.uploadFileType ? 'Link?' : 'File?'}`}
        />
      </Modal>
      <Modal open={isSubModel} onClose={onCloseSubModal} maxWidth={'400px'}>
        <InviteTeamsModal
          onCancel={onCloseSubModal}
          project_id={params?.id}
          isTextVisible={true}
          projectName={currentProject?.name}
          workspace_id={workspace?.id || ''}
        />
      </Modal>
      <Modal open={isAddMilestoneModalOpen} onClose={onCloseMilestoneModal} maxWidth={'462px'}>
        <MilestoneModal onClose={onCloseMilestoneModal} projectId={params?.id} />
      </Modal>
      <Modal open={isFileModalOpen} onClose={closeFileModel} maxWidth={'462px'}>
        <FilesModal onClose={closeFileModel} itemData={itemData} modalData={LINK_FILE_DATA.FOLDER} isProjectResource />
      </Modal>
      <Modal open={isOpen} onClose={cancelModel} maxWidth={'462px'}>
        <LinkFileModal onClose={cancelModel} modalData={LINK_FILE_DATA.RESOURCES} itemData={itemData} />
      </Modal>
    </>
  );
};

export default observer(Overview);
